import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { ClockIcon, BookOpenIcon, ZapIcon, UsersIcon } from 'lucide-react';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const cardVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function Beneficios() {
  return <section id="beneficios" className="py-20 md:py-28 bg-white" data-id="element-1">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
        {/* Section Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-16" data-id="element-3">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-navy-900 mb-4" data-id="element-4">
            Los <span className="text-gold-600" data-id="element-5">Beneficios</span>
          </h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-6">
            Diseñado pensando en las necesidades reales de los docentes
            argentinos
          </p>
        </motion.div>

        {/* Benefits Grid */}
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true
      }} className="grid md:grid-cols-2 gap-8" data-id="element-7">
          {/* Benefit 1 */}
          <motion.div variants={cardVariants} className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 border border-gray-100 shadow-sm" data-id="element-8">
            <div className="w-14 h-14 bg-gold-100 rounded-2xl flex items-center justify-center mb-6" data-id="element-9">
              <ClockIcon className="h-7 w-7 text-gold-600" data-id="element-10" />
            </div>
            <h3 className="text-xl md:text-2xl font-bold text-navy-900 mb-3" data-id="element-11">
              Adiós al "Domingo de Planificación"
            </h3>
            <p className="text-gray-600 leading-relaxed" data-id="element-12">
              No pierdas más horas frente a la hoja en blanco. Descarga, imprime
              y ve a clase. Recuperá tus fines de semana para vos y tu familia.
            </p>
          </motion.div>

          {/* Benefit 2 */}
          <motion.div variants={cardVariants} className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 border border-gray-100 shadow-sm" data-id="element-13">
            <div className="w-14 h-14 bg-blue-100 rounded-2xl flex items-center justify-center mb-6" data-id="element-14">
              <BookOpenIcon className="h-7 w-7 text-blue-600" data-id="element-15" />
            </div>
            <h3 className="text-xl md:text-2xl font-bold text-navy-900 mb-3" data-id="element-16">
              Curriculum 2026 Actualizado
            </h3>
            <p className="text-gray-600 leading-relaxed" data-id="element-17">
              Contenidos alineados exactamente a los núcleos de aprendizaje
              prioritarios (NAP) y diseños curriculares vigentes. Siempre al
              día.
            </p>
          </motion.div>

          {/* Benefit 3 */}
          <motion.div variants={cardVariants} className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 border border-gray-100 shadow-sm" data-id="element-18">
            <div className="w-14 h-14 bg-green-100 rounded-2xl flex items-center justify-center mb-6" data-id="element-19">
              <ZapIcon className="h-7 w-7 text-green-600" data-id="element-20" />
            </div>
            <h3 className="text-xl md:text-2xl font-bold text-navy-900 mb-3" data-id="element-21">
              Material "Plug & Play"
            </h3>
            <p className="text-gray-600 leading-relaxed" data-id="element-22">
              Archivos listos para el aula. Adaptamos el lenguaje técnico para
              que tus alumnos realmente entiendan y amen la materia.
            </p>
          </motion.div>

          {/* Benefit 4 */}
          <motion.div variants={cardVariants} className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 border border-gray-100 shadow-sm" data-id="element-23">
            <div className="w-14 h-14 bg-purple-100 rounded-2xl flex items-center justify-center mb-6" data-id="element-24">
              <UsersIcon className="h-7 w-7 text-purple-600" data-id="element-25" />
            </div>
            <h3 className="text-xl md:text-2xl font-bold text-navy-900 mb-3" data-id="element-26">
              Versatilidad Total
            </h3>
            <p className="text-gray-600 leading-relaxed" data-id="element-27">
              Ideal para colegios públicos, privados, bachilleratos de adultos o
              apoyo escolar particular. Se adapta a cualquier contexto
              educativo.
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}